import { Link } from "react-router-dom";
import type { Chapter } from "@/types/comic";
import { formatDate } from "@/lib/format";

interface ChapterListProps {
  comicId: string;
  chapters: Chapter[];
}

export default function ChapterList({ comicId, chapters }: ChapterListProps) {
  const ordered = [...chapters].sort((a, b) => b.number - a.number);

  return (
    <section className="rounded-lg bg-background-100 border border-background-200 p-4 md:p-6">
      <div className="flex items-center justify-between mb-5">
        <h2 className="font-heading font-bold text-lg text-foreground-950 flex items-center gap-2">
          <i className="ri-list-ordered text-primary-500" />
          章节列表
        </h2>
        <span className="text-xs text-foreground-500">共 {chapters.length} 话 · 按更新时间倒序</span>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-2.5">
        {ordered.map((chapter) => (
          <Link
            key={chapter.id}
            to={`/read/${comicId}/${chapter.id}`}
            className="group flex flex-col gap-1 p-3 rounded-md bg-background-50 border border-background-200 hover:border-primary-400 transition-colors"
          >
            <span className="text-sm text-foreground-950 truncate group-hover:text-primary-500 transition-colors">
              第 {chapter.number} 话 · {chapter.title}
            </span>
            <span className="text-xs text-foreground-500 flex items-center gap-1">
              <i className="ri-time-line" />
              {formatDate(chapter.updatedAt)}
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}